import { isProviderCreditsExhaustedText, PROVIDER_CREDITS_EXHAUSTED_MESSAGE } from '@shared/aiProviderStatus';

export type ApiErrorDetails = { message: string; retryable?: boolean; code?: string; correlationId?: string };

/** Pure decoder shared by transport and presentation layers; it must never import UI. */
export function extractApiErrorDetails(raw: string): ApiErrorDetails {
  if (isProviderCreditsExhaustedText(raw)) return { message: PROVIDER_CREDITS_EXHAUSTED_MESSAGE, retryable: false };
  const fallback = raw || 'Errore API';
  const candidates = [raw];
  const jsonStart = raw.indexOf('{');
  if (jsonStart > 0) candidates.push(raw.slice(jsonStart));
  for (const candidate of candidates) {
    try {
      const payload = JSON.parse(candidate) as { message?: unknown; error?: unknown; retryable?: unknown; code?: unknown; correlationId?: unknown; reason?: unknown };
      const message = typeof payload.message === 'string' && payload.message.trim()
        ? payload.message
        : typeof payload.error === 'string' && payload.error.trim()
          ? payload.error
          : null;
      // Il motivo operativo (es. i 409 del registro Brand con `reason`) deve
      // arrivare all'utente: lo appendiamo al messaggio principale quando e'
      // una stringa distinta, senza trasformarlo in codice macchina.
      const reason = typeof payload.reason === 'string' && payload.reason.trim()
        ? payload.reason.trim()
        : null;
      const finalMessage = reason && reason !== message?.trim() ? `${message} — ${reason}` : message;
      // Alcune route legacy usano ancora `error` per restituire un codice
      // macchina (per esempio SIGNAL_STATE_CHANGED) invece del campo `code`.
      // Manteniamo compatibilità senza trasformare messaggi umani in codici.
      const legacyCode = typeof payload.error === 'string' && /^[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)+$/.test(payload.error)
        ? payload.error
        : undefined;
      if (finalMessage) return {
        message: finalMessage,
        retryable: typeof payload.retryable === 'boolean' ? payload.retryable : undefined,
        code: typeof payload.code === 'string' ? payload.code : legacyCode,
        correlationId: typeof payload.correlationId === 'string' ? payload.correlationId : undefined,
      };
    } catch {
      // Prova il candidato successivo; le risposte non JSON conservano il testo originale.
    }
  }
  return { message: fallback };
}
